import React from 'react';
import styled from 'styled-components';
import RouteRedirect from '../../common/RouteRedirect';
import DashboardTemplate from '../../common/DashboardTemplate';
import routes, { redirects } from './routes';

const ContentWrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  margin-left: 45px;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const MyForms = () => {
  return (
    <DashboardTemplate
      stripeHeaderTitle="Forms"
      showSubmenu={false}
      routes={routes}
      redirects={redirects}
      render={(renderPropsData) => (
        <ContentWrapper>
          <RouteRedirect {...renderPropsData} />
        </ContentWrapper>
      )}
    />
  );
};

export default MyForms;
